
import React from "react";
import type { PaymentDetails } from "@/types/payment";

interface TransactionDetailsSectionProps {
  paymentDetails: PaymentDetails | null;
}

export const TransactionDetailsSection = ({ paymentDetails }: TransactionDetailsSectionProps) => {
  if (!paymentDetails) return null;

  return (
    <div className="bg-tribal-light rounded-lg p-3 w-full">
      <p className="font-medium text-sm sm:text-base">Transaction Details:</p>
      <p className="text-xs sm:text-sm text-tribal-neutral">Name: {paymentDetails.customerName || "N/A"}</p>
      <p className="text-xs sm:text-sm text-tribal-neutral break-all">Email: {paymentDetails.customerEmail || "N/A"}</p>
      <p className="text-xs sm:text-sm text-tribal-neutral">
        Amount: ${paymentDetails.amountTotal?.toFixed(2) || "0.00"} {paymentDetails.currency?.toUpperCase()}
      </p>
      <p className="text-xs sm:text-sm text-tribal-neutral break-all">Session ID: {paymentDetails.id}</p>
      <p className="text-xs sm:text-sm text-tribal-neutral">Date: {new Date().toLocaleDateString()}</p>
    </div>
  );
};
